import { environment } from '@/scripts/environments'
import { HStack, Link, Text } from '@chakra-ui/react'
import { useLocation } from '@tanstack/react-router'
import { ArrowRightIcon } from 'lucide-react'
import { newBackofficeUrl } from './newBackofficeUrl'

export function NewBackofficeBanner() {
  const { href } = useLocation()
  const target = newBackofficeUrl(href, import.meta.env.BASE_URL, environment)

  return (
    <HStack
      as="section"
      aria-label="New backoffice"
      justifyContent="center"
      gap={3}
      px={4}
      h="var(--new-backoffice-banner-height)"
      bg="yellow.300"
      color="gray.900"
      fontSize="md"
      flexShrink={0}
    >
      <Text>
        This backoffice is being replaced. Please use the new backoffice
        instead.
      </Text>
      <Link
        href={target}
        fontWeight="bold"
        color="gray.900"
        textDecoration="underline"
      >
        Open this page in the new backoffice
        <ArrowRightIcon size={16} />
      </Link>
    </HStack>
  )
}
